export default "__VITE_ASSET__DNbMI0yF__"